'use client';

import { CheckCheckIcon, CopyIcon } from 'lucide-react';
import { useState } from 'react';
import { Button } from './ui/button';

interface CopyButtonProps {
  code: string;
}

export function CodeCopyButton({ code }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="absolute right-2 top-2 z-10">
      <Button
        onClick={handleCopy}
        size="icon"
        variant="ghost"
        className="transition-all opacity-0 group-hover:opacity-100 text-white rounded-full"
      >
        {copied ? (
          <CheckCheckIcon className="w-4 h-4" />
        ) : (
          <CopyIcon className="w-4 h-4" />
        )}
      </Button>
    </div>
  );
}
